import { makeStyles } from '@mui/styles';
import { Colors, Shadow } from 'utils';

export const claimDetailsStyle = makeStyles(() => ({
    refreshClaimBtn: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '36px',
        height: '36px',
        borderRadius: '4px',
        border: '1px solid #E4E7EC',
        background: '#FFF',
        boxShadow: '0px 1px 2px 0px rgba(16, 24, 40, 0.05)',
    },
    claimDetailsContainerStyle: {
        width: '100%',
        backgroundColor: Colors.BackgroundWhite,
        borderRadius: '8px',
        boxShadow: Shadow.noteModalShadow,
        padding: '24px',
        '@media(max-width: 1280px)': { padding: '16px' },
    },
    claimDetailsStyle: {
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '16px',
    },
    closeButnStyle: {
        border: 'none',
        outline: 'none',
        padding: '0 16px',
        height: '36px',
        borderRadius: '4px',
        backgroundColor: Colors.ThemeRed,
        fontSize: '14px',
        fontWeight: 600,
        color: Colors.BackgroundWhite,
        '&.closed': {
            backgroundColor: Colors.BackgroundWater,
            color: Colors.ThemeRed,
            cursor: 'default',
        },
    },
    submitClaimBtn: {
        border: 'none',
        outline: 'none',
        padding: '0 16px',
        height: '36px',
        borderRadius: '4px',
        backgroundColor: Colors.ThemeBlue,
        fontSize: '14px',
        fontWeight: 600,
        color: Colors.BackgroundWhite,
    },
    claimDetailsFirstPartStyle: {
        width: '100%',
        backgroundColor: Colors.BackgroundWhite,
        borderRadius: '8px',
        boxShadow: '0px 0px 6px #8A8A8A3D',
        marginBottom: '24px',
        padding: '16px',
        '@media(max-width: 1280px)': { padding: '8px' },
    },
    claimOutlineStyle: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: '8px',
    },
    claimIdTextBoxStyle: {
        fontSize: '16px',
        fontWeight: 600,
        color: Colors.TextSecondary,
    },
    claimDetailsListStyleBox: {
        borderRadius: '8px',
        border: '1px solid #E4E7EC',
        background: '#FFF',
        padding: 16,
    },
    claimDetailsListStyle: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: '8px 16px',
        width: '100%',
        '& li': {
            flexGrow: 1,
            width: '32%',
            maxWidth: '32%',
            padding: '9px 16px',
            '@media(max-width: 1280px)': { padding: '9px 8px' },
            backgroundColor: Colors.BackgroundCatskillWhite,
            borderRadius: '8px',
            '& > span': {
                fontSize: '14px',
                fontWeight: 600,
                color: Colors.TextSecondary,
                '& em': {
                    fontSize: 'inherit',
                    fontWeight: 500,
                    color: Colors.TextMiddleGray,
                    marginLeft: '8px',
                },
            },
        },
    },
    claimInfoBoxStyle: {
        // maxWidth: "728px",
        width: 'fit-content',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        padding: '8px 16px',
        backgroundColor: '#347AF01A',
        marginBottom: '24px',
        borderRadius: '4px',
        '& > img': { marginRight: '8px' },
    },
    claimInfoStyle: {
        fontSize: '14px',
        lineHeight: '24px',
        fontWeight: 500,
        color: Colors.TextPrimary,
    },
    claimDetailsSecondPartStyle: { width: '100%' },
    claimDetailsTitleBoxStyle: {
        fontSize: '18px',
        fontWeight: 700,
        color: Colors.TextSecondary,
        textTransform: 'capitalize',
    },
    closeClaimWrapperStyle: {
        '& > button': { backgroundColor: Colors.BackgroundWater },
        padding: 0,
    },
}));

export const generateClaimStyle = makeStyles(() => ({
    refreshTitle: {
        color: '#172B4D',
        fontSize: '20px',
        fontWeight: '700',
        lineHeight: '28px',
        padding: '24px',
    },
    generateClaimContainerStyle: {
        width: '100%',
        borderRadius: '8px',
        backgroundColor: Colors.BackgroundWhite,
        padding: '24px',
        '@media(max-width: 1280px)': { padding: '16px' },
    },
    generateClaimActionsStyle: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-end',
        marginBottom: '24px',
    },
    mergeBillsBoxStyle: {
        display: 'flex',
        alignItems: 'center',
    },
    mergeBillsTitleStyle: {
        fontSize: '14px',
        fontWeight: 600,
        color: Colors.TextSecondary,
        marginRight: '8px',
    },
    tableAndPaginationBoxStyle: {
        minHeight: '500px',
        display: 'flex',
        flexDirection: 'column',
    },
    tableBoxStyle: { flexGrow: 1 },
    loaderContainerStyle: {
        minHeight: '400px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    notClaimedBillsFooterStyle: {
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '16px 0 0',
    },
    generateOrCancelButnStyle: {
        maxWidth: '540px',
        '@media(max-width: 1440px)': { maxWidth: '446px' },
        width: '100%',
        '& button': {
            width: '262px',
            '@media(max-width: 1440px)': { width: '215px' },
            height: '36px !important',
            fontSize: '14px !important',
            '&:first-of-type': {
                backgroundColor: `${Colors.BackgroundWater} !important`,
            },
        },
    },
    infoIcon: {
        marginLeft: '16px',
    },

    closeButtonWrapper: {
        display: 'flex',
        justifyContent: 'flex-end',
        marginRight: '-50px',
        marginBottom: '-30px',
    },

    closeBill: {
        display: 'flex',
        justifyContent: 'flex-end',
        width: '100%',
        margin: '24 0',
        '& button': {
            width: '109px',
            height: '36px',
            background: '#D72525 0% 0% no-repeat padding-box',
            borderRadius: '18px',
            color: Colors.TextWhite,
            fontSize: '14px',
            fontWeight: '600',
            border: 'none',
        },
        '& button:hover': {
            background: '#ac0707',
        },
    },

    itemsSection: {
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
        marginTop: '24px',
    },

    addButtonsWrapper: {
        display: 'flex',
        marginTop: '24px',
    },

    requestCorrection: {
        width: '260px',
        height: '48px',
        border: '1px solid #D0D5DD',
        background: '#FFF',
        boxShadow: '0px 1px 2px 0px rgba(16, 24, 40, 0.05)',
        borderRadius: '4px',
        fontSize: '16px',
        fontWeight: '600',
        color: '#172B4D',
    },

    itemsWrapper: {
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        height: 'auto',
        maxHeight: '50px',
        padding: '16px',
        background: '#E6ECF3 0% 0% no-repeat padding-box',
        borderRadius: '8px',
    },

    billingHistory: {
        marginLeft: '50px',
    },

    paperWrapper: {
        width: '800px',
        height: '90vh',
        background: 'white',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
    },

    paperFooter: {
        height: '80px',
        padding: '10px 0',
        background: '#42526E',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'fixed',
        left: 0,
        bottom: 0,
    },
    draftBtnBox: {
        padding: '10px 16px',
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        color: '#FFF',
        fontSize: '16px',
        fontWeight: '700',
        lineHeight: '19px',
    },
}));
